import { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import Tooltip from '../../../juristec-ui/core/Tooltip';
import IconButton from '../../../juristec-ui/core/IconButton';
import Button from '../../../juristec-ui/core/Button';
import SearchFilter from '../../../juristec-ui/core/SearchFilter';
import {
  Add, ArrowLeft, Chain, CloneDash, Edit, Import, Restore, Trash,
} from '../../../juristec-ui/icons';
import {
  DashboardAvatarInformation,
  GridDashboardToolbarStyled,
  DashboardWelcomeInformation,
  DashboardActions,
} from './styled/GridDashboardToolbar.styled';

const gridDashboardToolbarDefaultPropUser = {
  name: '',
};

const gridDashboardToolbarDefaultPropDashboards = [];
const gridDashboardToolbarDefaultPropSaveLayout = () => {};
const gridDashboardToolbarDefaultPropImportDashboard = () => {};
const gridDashboardToolbarDefaultPropSetEditLayout = () => {};
const gridDashboardToolbarDefaultPropSetFilterText = () => {};
const gridDashboardToolbarDefaultPropSelectedGroups = {};
const gridDashboardToolbarDefaultPropSetSelectedGroups = () => {};
const gridDashboardToolbarDefaultPropSetSelectedGeneral = () => {};
const gridDashboardToolbarDefaultPropSetOpenTrashCan = () => {};
const gridDashboardToolbarDefaultPropClearTrashCan = () => {};
const gridDashboardToolbarDefaultPropGroups = {};
const gridDashboardToolbarDefaultPropHandleCreateModal = () => {};
const gridDashboardToolbarDefaultPropHandleGetDashsUrls = () => {};
const gridDashboardToolbarDefaultPropTourContext = {};

const GridDashboardToolbar = ({
  user = gridDashboardToolbarDefaultPropUser,
  dashboards = gridDashboardToolbarDefaultPropDashboards,
  saveLayout = gridDashboardToolbarDefaultPropSaveLayout,
  editPainel = false,
  setEditLayout = gridDashboardToolbarDefaultPropSetEditLayout,
  isLoading = false,
  setFilterText = gridDashboardToolbarDefaultPropSetFilterText,
  selectedGroups = gridDashboardToolbarDefaultPropSelectedGroups,
  setSelectedGroups = gridDashboardToolbarDefaultPropSetSelectedGroups,
  selectedGeneral = '',
  setSelectedGeneral = gridDashboardToolbarDefaultPropSetSelectedGeneral,
  openTrashCan = false,
  setOpenTrashCan = gridDashboardToolbarDefaultPropSetOpenTrashCan,
  trashCount = 0,
  clearTrashCan = gridDashboardToolbarDefaultPropClearTrashCan,
  //
  filteredDash = gridDashboardToolbarDefaultPropDashboards,
  multiSelection,
  selectedCards,
  toggleAllSelected,
  setMultiSelection,
  trashSelected,
  deleteSelected,
  //
  groups = gridDashboardToolbarDefaultPropGroups,
  handleCreateModal = gridDashboardToolbarDefaultPropHandleCreateModal,
  handleGetDashsUrls = gridDashboardToolbarDefaultPropHandleGetDashsUrls,
  importDashboard = gridDashboardToolbarDefaultPropImportDashboard,
  tourContext = gridDashboardToolbarDefaultPropTourContext,
}) => {
  const cronRef = useRef();
  const [searchText, setSearchText] = useState('');
  // const [openAddModal, setOpenAddModal] = useState(false);

  const handleSearch = (txt) => {
    setSearchText(txt);
    clearTimeout(cronRef.current);
    cronRef.current = setTimeout(() => {
      setFilterText(txt);
    }, 200);
  };

  return (
    <GridDashboardToolbarStyled openTrashCan={openTrashCan} editPainel={editPainel}>
      {!openTrashCan ? (
        <DashboardWelcomeInformation>
          <h1>
            Olá,
            {` ${user?.name}!`}
          </h1>
          <>
            <h3>
              Dashboards:
              <span>{` ${dashboards?.filter((d) => !d.isDeleted).length || 0}`}</span>
            </h3>
          </>
        </DashboardWelcomeInformation>
      ) : (
        <div className="gap-fix">
          <DashboardAvatarInformation>
            <Tooltip text="Voltar" direction="right">
              <IconButton variant="contained" color="secondary" size="medium" shape="rounded" onClick={() => setOpenTrashCan(false)}>
                <ArrowLeft />
              </IconButton>
            </Tooltip>
          </DashboardAvatarInformation>
          <DashboardWelcomeInformation>
            <h1>
              Lixeira
            </h1>
            <h3>
              Dashboards:
              <span>{` ${trashCount}`}</span>
            </h3>
          </DashboardWelcomeInformation>
        </div>
      )}
      <DashboardActions editPainel={editPainel} openTrashCan={openTrashCan}>
        {!!editPainel && (
          <Button variant="contained" color="secondary" onClick={() => saveLayout()}>
            Salvar
          </Button>
        )}
        {!!openTrashCan && !multiSelection && (
          <>
            <Tooltip text="Ações em lote">
              <IconButton
                variant="pattern"
                color="primary"
                shape="rounded"
                onClick={setMultiSelection}
              >
                <CloneDash />
              </IconButton>
            </Tooltip>
            <Button
              variant="contained"
              color="secondary"
              shape="rounded"
              size="medium"
              className="action-trash"
              onClick={() => clearTrashCan()}
            >
              Esvaziar Lixeira
            </Button>
          </>
        )}
        {!!multiSelection && (
          <>
            <span>
              {`${selectedCards.size} selecionados`}
            </span>
            <Button
              variant={selectedCards.size === filteredDash.length ? 'contained' : 'outlined'}
              color={selectedCards.size === filteredDash.length ? 'secondary' : 'primary'}
              onClick={toggleAllSelected}
              textTransform="none"
              size="small"
            >
              Selecionar todos
            </Button>
            <Tooltip
              text={openTrashCan ? 'Restaurar selecionados' : 'Mover selecionados para a Lixeira'}
              direction="left"
            >
              <IconButton
                variant="pattern"
                color="primary"
                size="medium"
                shape="rounded"
                onClick={trashSelected}
                disabled={selectedCards.size === 0}
              >
                {openTrashCan ? <Restore /> : <Trash />}
              </IconButton>
            </Tooltip>
            {!!openTrashCan && (
              <Tooltip
                text="Apagar selecionados"
                direction="left"
              >
                <IconButton
                  variant="pattern"
                  color="primary"
                  size="medium"
                  shape="rounded"
                  onClick={deleteSelected}
                  disabled={selectedCards.size === 0}
                >
                  <Trash />
                </IconButton>
              </Tooltip>
            )}
            <Button variant="contained" color="secondary" onClick={setMultiSelection}>
              Voltar
            </Button>
          </>
        )}
        {!(editPainel || openTrashCan || multiSelection) && (
          <>
            <SearchFilter
              radioLabel="Geral"
              radioOptions={[
                { label: 'Todos os Dashboards', value: 'all' },
                { label: 'Meus Dashboards', value: 'my' },
                { label: 'Compartilhados Comigo', value: 'shared' },
                { label: 'Dashboards Favoritos', value: 'bookmarked' },
              ]}
              radioSelected={selectedGeneral}
              setRadioSelected={setSelectedGeneral}
              checkboxLabel="Grupos"
              checkboxOptions={Object.keys(groups).reduce((aux, g) => {
                aux[g] = groups[g]?.value || g;
                return aux;
              }, { 'Sem Grupo': '' })}
              checkboxSelected={selectedGroups}
              setCheckboxSelected={setSelectedGroups}
              textSearch={searchText}
              setTextSearch={handleSearch}
            />
            {trashCount > 0 && (
              <Tooltip text="Lixeira">
                <IconButton
                  variant="outlined"
                  color="primary"
                  shape="rounded"
                  size="medium"
                  className="action-trash"
                  onClick={() => setOpenTrashCan(true)}
                >
                  <Trash />
                  <span style={{ fontWeight: 'bold' }}>{` (${trashCount})`}</span>
                </IconButton>
              </Tooltip>
            )}
            <Tooltip text="Reposicionar Dashboards">
              <IconButton
                variant="pattern"
                color="primary"
                shape="rounded"
                onClick={() => setEditLayout(true)}
              >
                <Edit />
              </IconButton>
            </Tooltip>
            {user?.role !== 'guest' && (
              <>
                <Tooltip text="Importar Dashboard">
                  <IconButton
                    variant="pattern"
                    color="primary"
                    shape="rounded"
                    onClick={importDashboard}
                  >
                    <Import />
                  </IconButton>
                </Tooltip>
                <Tooltip text="Links dos Dashboards">
                  <IconButton
                    variant="pattern"
                    color="primary"
                    shape="rounded"
                    onClick={handleGetDashsUrls}
                  >
                    <Chain />
                  </IconButton>
                </Tooltip>
                <Tooltip text="Ações em lote">
                  <IconButton
                    variant="pattern"
                    color="primary"
                    shape="rounded"
                    onClick={setMultiSelection}
                  >
                    <CloneDash />
                  </IconButton>
                </Tooltip>
                <Tooltip text="Adicionar dashboard" className="action-button">
                  <IconButton
                    id="createDashboard_first"
                    variant="contained"
                    color="secondary"
                    shape="rounded"
                    onClick={handleCreateModal}
                    isLoading={isLoading}
                  >
                    <Add />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </>
        )}
      </DashboardActions>
    </GridDashboardToolbarStyled>
  );
};

GridDashboardToolbar.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    role: PropTypes.string.isRequired,
  }),
  dashboards: PropTypes.arrayOf(PropTypes.shape({})),
  filteredDash: PropTypes.arrayOf(PropTypes.shape({})),
  saveLayout: PropTypes.func,
  importDashboard: PropTypes.func,
  editPainel: PropTypes.bool,
  setEditLayout: PropTypes.func,
  isLoading: PropTypes.bool,
  setFilterText: PropTypes.func,
  selectedGroups: PropTypes.shape({}),
  setSelectedGroups: PropTypes.func,
  selectedGeneral: PropTypes.string,
  setSelectedGeneral: PropTypes.func,
  openTrashCan: PropTypes.bool,
  setOpenTrashCan: PropTypes.func,
  trashCount: PropTypes.number,
  clearTrashCan: PropTypes.func,
  multiSelection: PropTypes.func.isRequired,
  selectedCards: PropTypes.instanceOf(Map).isRequired,
  toggleAllSelected: PropTypes.func.isRequired,
  setMultiSelection: PropTypes.func.isRequired,
  trashSelected: PropTypes.func.isRequired,
  deleteSelected: PropTypes.func.isRequired,
  groups: PropTypes.shape({}),
  handleCreateModal: PropTypes.func,
  handleGetDashsUrls: PropTypes.func,
  tourContext: PropTypes.shape({}),
};

export default GridDashboardToolbar;
